import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import scrollEvent from './scrollEvent'
import Hidden from 'material-ui/Hidden'
import Paper from 'material-ui/Paper';
import Menu from 'material-ui-icons/Menu';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';
import Button from 'material-ui/Button';
import Logo from 'images/logo.svg';
import { ListItem } from 'material-ui/List';
import APP_CONFIG from 'config/app.json';
import Close from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';


export class Navbar extends Component {
  constructor(props){
    super(props)
    console.log(process.env.PUBLIC_URL)
    this.state = {
      change_position:100
    }
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  componentDidMount(){
    const navbar = document.getElementById('navbar');
    scrollEvent(() => {
      let windowY = window.pageYOffset;
      if(windowY > this.state.change_position){
        navbar.classList.add('nav-on')
        navbar.classList.add('fixed-top')
      } else {
        navbar.classList.remove('nav-on')
        navbar.classList.remove('fixed-top')
      }
    });
  }

  handleDrawerClose = () => {
    this.setState({ open: false });
  };
  
  render(){
    const acriveStyle = {
      fontWeight: 'bold',
      color: APP_CONFIG.base_color
    }
    /**
     * drawer
     */
    const sideList = (
        <div className="drawer">
            <IconButton className="drawer-close" onClick={this.handleDrawerClose}>
            <Close />
            </IconButton>
          <Divider />
          {
            Object.keys(APP_CONFIG.contents_nav).map((key,i) => {
              return (
                <ListItem button
                    className="drawer-list"
                    key={`listlink_${i}`}
                    component={NavLink}
                    to={`/${key}/`}
                    activeStyle={acriveStyle}
                    >
                    {key}
                </ListItem>
              )
            })
          }
        </div>
    );
    
    return(
      <nav id="navbar" className="navbar">
        <Link to="/" className="navbar-brand"><h1><img className="header-logo" src={Logo} alt="JLN" /></h1></Link>
        <div className="collapse navbar-collapse">
            <Hidden xsDown className="show-pc">
              <Paper>
              <ul className="navbar-nav ml-auto">
              {
                Object.keys(APP_CONFIG.contents_nav).map((key,i) => {
                  return (
                    <li className="nav-item" key={`navlink_${i}`}>
                      <Button
                        component={NavLink}
                        to={`/${key}/`}
                        activeStyle={acriveStyle}
                        color="primary"
                        >
                        {key}
                      </Button>
                    </li>
                  )
                })
              }
              </ul>
              </Paper>
            </Hidden>
          <Hidden smUp>
            <Menu className="sp-nav-link" onClick={this.toggleDrawer('right', true)} />
            <Drawer anchor="right" open={this.state.right} onClose={this.toggleDrawer('right', false)}>
              <div
                tabIndex={0}
                role="button"
                onClick={this.toggleDrawer('right', false)}
                onKeyDown={this.toggleDrawer('right', false)}
              >
                {sideList}
              </div>
          </Drawer>
          </Hidden>
        </div>
      </nav>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/Navbar.js